import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import VerifyUser from './components/auth/VerifyUser';
import Dashboard from './components/dashboard/Dashboard';
import SearchPanel from './components/search/SearchPanel';
import RansomwarePanel from './components/ransomware/RansomwarePanel';
import useAuthStore from './store/authStore';

function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuthStore();
  
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  
  return children;
}

function PublicRoute({ children }) {
  const { isAuthenticated } = useAuthStore();
  
  if (isAuthenticated) {
    return <Navigate to="/" />;
  }
  
  return children;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
        <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
        <Route path="/verify-user" element={<PublicRoute><VerifyUser /></PublicRoute>} />
        
        <Route path="/" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
        <Route path="/search" element={<ProtectedRoute><Layout><SearchPanel /></Layout></ProtectedRoute>} />
        <Route path="/ransomware" element={<ProtectedRoute><Layout><RansomwarePanel /></Layout></ProtectedRoute>} />
      </Routes>
    </Router>
  );
}

export default App; 